import { render } from "./confirm-email.vue?vue&type=template&id=3c00e2d2"
import script from "./confirm-email.vue?vue&type=script&lang=js"
export * from "./confirm-email.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__